// import axios from '@/lib/axios';
import config from './config';

//查询用户配额
function getUserQuotas(params) {
  return Ajax.get(config.userQuotas, params);    
}

function addBandwidthPackageToCar(params) {
	return Ajax.post(config.addBandwidthPackageToCar, params,{
				headers: {
					'Content-Type': 'application/json'
				}
			});  
}
export {
  // getBandwidthPackageStock,
  getUserQuotas,
  addBandwidthPackageToCar
};


// WEBPACK FOOTER //
// ./src/api/sbw/create/actions.js